<template>
    <main class="container_defense_mobile" id="DefenseMobile">
        <!--section top -->
        <section class="container_defense_mobile__section_top">
            <!-- article top -->
            <article class="container_defense_mobile__section_top__article_top">
                <aside class="container_defense_mobile__section_top__article_top__aside">
                    <div class="container_defense_mobile__section_top__article_top__aside__div">
                        <h1 class="container_defense_mobile__section_top__article_top__aside__div__h1">
                            Défense
                        </h1>
                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_defense_mobile__section_top__article_bottom">
                <aside class="container_defense_mobile__section_top__article_bottom__aside">
                    <div class="container_defense_mobile__section_top__article_bottom__aside__div_top">
                        <img src="@/assets/waffen1.jpg" alt="Defense"
                            class="container_defense_mobile__section_top__article_bottom__aside__div_top__img">
                    </div>
                    <!-- div bottom -->
                    <div class="container_defense_mobile__section_top__article_bottom__aside__div_bottom">
                        <p class="container_defense_mobile__section_top__article_bottom__aside__div_bottom__p">
                            Conseil défense du domicile, techniques d'auto défense.
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
            </article>
        </section>
        <!-- section bottom-->
        <section class="container_defense_mobile__section_bottom">
            <article class="container_defense_mobile__section_bottom__article_top">
                <aside class="container_defense_mobile__section_bottom__article_top__aside_top">
                    <div class="container_defense_mobile__section_bottom__article_top__aside_top__div_title">
                        <h1 class="container_defense_mobile__section_bottom__article_top__aside_top__div_title__h1">
                            Tarif
                        </h1>
                    </div>
                    <!-- div -->
                    <div class="container_defense_mobile__section_bottom__article_top__aside_top__div_text">
                        <p class="container_defense_mobile__section_bottom__article_top__aside_top__div_text__p">
                            - 140 € /jour <br>
                        </p>
                        <p class="container_defense_mobile__section_bottom__article_top__aside_top__div_text__prix">
                            Prix total : 1 700 €
                        </p>
                    </div>
                </aside>
                <!-- aside bottom-->
                <aside class="container_defense_mobile__section_bottom__article_top__aside_bottom">
                    <div class="container_defense_mobile__section_bottom__article_top__aside_bottom__div_left">
                        <router-link
                            class="container_defense_mobile__section_bottom__article_top__aside_bottom__div_left__router-link"
                            to="/contact">
                            <p
                                class="container_defense_mobile__section_bottom__article_top__aside_bottom__div_left__router-link__p">
                                Choisir
                            </p>
                        </router-link>
                    </div>
                    <!-- button -->
                </aside>
            </article>
            <!-- article bottom-->
            <article class="container_defense_mobile__section_bottom__article_bottom">
                <aside class="container_defense_mobile__section_bottom__article_bottom__aside_left">
                    <router-link
                        class="container_defense_mobile__section_bottom__article_bottom__aside_left__router-link"
                        to="/instruction">
                        <button
                            class="container_defense_mobile__section_bottom__article_bottom__aside_left__router-link__button">
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back"  id="div_button">
                                <img src="@/assets/back.png" alt="back"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_left__router-link__button__div_back__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
                <!-- aside right -->
                <aside class="container_defense_mobile__section_bottom__article_bottom__aside_right">
                    <router-link
                        class="container_defense_mobile__section_bottom__article_bottom__aside_right__router-link"
                        to="/istc">
                        <button
                            class="container_defense_mobile__section_bottom__article_bottom__aside_right__router-link__button">
                            <div
                                class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next"  id="div_button">
                                <img src="@/assets/next.png" alt="next"
                                    class="container_applicationweb_mobile__section_bottom__article_bottom__aside_right__router-link__button__div_next__img" id="button_arrow">
                            </div>
                        </button>
                    </router-link>
                </aside>
            </article>
        </section>
    </main>
</template>

<script >
export default {
    name: 'DefenseMobile',
}
</script>

<style  lang=scss>
router-link {
    display: block;
}

@import "@/style/components/Services/Defense/DefenseMobile.scss";

@media screen and(min-width: 926px) {
    #DefenseMobile {
        display: none;
    }
}
</style>